import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchProductCategoryRequest,
  fetchProductCategorySuccess,
  fetchProductCategoryFailure,
} from './ProductCategorySlice';

function fetchCategoryAPI(budid) {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/product/category`, {
    params: { budid }
  });
}

function* handleFetchCategory(action) {
  try {
    const response = yield call(fetchCategoryAPI, action.payload?.budid);
    yield put(fetchProductCategorySuccess(response.data));
  } catch (error) {
    yield put(fetchProductCategoryFailure(error.message || "Failed to fetch category data"));
  }
}

export default function* categorySaga() {
  yield takeLatest(fetchProductCategoryRequest.type, handleFetchCategory);
}
